import Vue from "vue"
Vue.mixin({
    beforeCreate: function () {
        if (this.$options.icons) {
            this.icons = this.$options.icons
            delete this.$options.icons
        }
    },
})
